import { render, staticRenderFns } from "./ChallengeContent.vue?vue&type=template&id=40d8c013"
import script from "./ChallengeContent.vue?vue&type=script&lang=js"
export * from "./ChallengeContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports